import { useAppDispatch, useAppSelector } from "@app/store";
import { useCallback } from "react";
import { addAdminWallet, addAdminWalletsForWithdrawals, deleteAdminWalletsForWithdrawals, getAdminBalances, getAdminWallet, getAdminWalletsForWithdrawals, getTradeBalance } from "./slice";
import { AddAdminWalletRequest, AddAdminWithdrawalWalletsRequest, DeleteAdminWithdrawalWalletsRequest, TradeBalanceRequest } from "./api";

export const useAdminBalances = () => {
  const state = useAppSelector((state) => state.adminBalances);
  const dispatch = useAppDispatch();

  const getAdminBalancesHandler = useCallback(
    () => dispatch(getAdminBalances()),
    [dispatch]
  );
  const getTradeBalanceHandler = useCallback(
    (data?: TradeBalanceRequest) => dispatch(getTradeBalance({ data })),
    [dispatch]
  );

  const addAdminWalletHandler = useCallback(
    (data: AddAdminWalletRequest) => dispatch(addAdminWallet({ data })),
    [dispatch]
  );

  const getAdminWalletHandler = useCallback(
    () => dispatch(getAdminWallet({})),
    [dispatch]
  );

  const getAdminWalletsForWithdrawalsHandler = useCallback(
    () => dispatch(getAdminWalletsForWithdrawals()),
    [dispatch]
  );
  const addAdminWalletsForWithdrawalsHandler = useCallback(
    (data: AddAdminWithdrawalWalletsRequest) => dispatch(addAdminWalletsForWithdrawals({ data })),
    [dispatch]
  );
  const deleteAdminWalletsForWithdrawalsHandler = useCallback(
    (data: DeleteAdminWithdrawalWalletsRequest) => dispatch(deleteAdminWalletsForWithdrawals({ data })),
    [dispatch]
  );

  return {
    state,
    getAdminBalances: getAdminBalancesHandler,
    getTradeBalance: getTradeBalanceHandler,
    addAdminWallet: addAdminWalletHandler,
    getAdminWallet: getAdminWalletHandler,
    getAdminWalletsForWithdrawals: getAdminWalletsForWithdrawalsHandler,
    addAdminWalletsForWithdrawals: addAdminWalletsForWithdrawalsHandler,
    deleteAdminWalletsForWithdrawals: deleteAdminWalletsForWithdrawalsHandler,
  };
};
